<template>
  <form
    enctype="multipart/form-data"
    novalidate
    @dragover.prevent
    @drop.prevent="HandleChange($event.dataTransfer.files)"
  >
    <div class="columns is-multiline">
      <div class="column is-12 has-text-centered content">
        <slot v-if="images.length == 0"></slot>

        <div v-if="images.length == 0" class="file is-centered" :class="[css]">
          <label class="file-label">
            <input
              type="file"
              :multiple="multiple"
              :name="fieldName"
              :disabled="false"
              accept="image/*"
              class="file-input"
              @change="HandleChange($event.target.files)"
            />
            <span class="file-cta">{{ btnName }}</span>
          </label>
        </div>

        <div class="buttons is-centered">
          <button
            v-if="images.length != 0 && !hideSave"
            class="button is-centered"
            :class="[css, { 'is-loading': isLoading }]"
            :disabled="isLoading"
            @click.prevent="!isLoading ? Save() : false"
          >
            Spara
          </button>

          <button
            v-if="images.length != 0 && !isLoading"
            class="button is-centered is-default"
            :class="[{ 'is-loading': isLoading }]"
            :disabled="isLoading"
            @click.prevent="images = []"
          >
            Rensa
          </button>
        </div>

        <progress
          v-show="isLoading"
          class="progress is-success margin-top-25"
          :value="procentDone"
          max="100"
          >{{ procentDone }}%</progress
        >
      </div>

      <div v-if="images.length != 0" class="column is-12">
        <div class="columns is-multiline">
          <div
            v-for="(image, index) in images"
            :key="index"
            :class="{ 'column is-2': !format }"
            @click="HandleRemove(image)"
          >
            <ProjectImage
              :hidden="true"
              :image="image.url"
              link
              :css="format"
            ></ProjectImage>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import ProjectImage from "@/components/singles/ProjectImage.vue";

export default {
  components: { ProjectImage },
  props: ["css", "btnName", "uid", "path", "multiple", "format", "hideSave"],
  data() {
    return {
      images: [],
      fieldName: "images",
      isLoading: false,
      procentDone: 0
    };
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {
    async Save(uid) {
      let results = [];

      this.isLoading = true;
      const images = [...this.images];
      let count = 0;
      let total = images.length;

      for (let image of images) {
        count = count + 1;
        let toSend = {
          ...image,
          uid: this.uid || uid
        };

        delete toSend.url;

        let result = await this.$helpers.PostApi(this.path, toSend);
        results = [result, ...results];
        this.$emit("completed", result);
        this.images = this.images.filter(x => x != image);
        this.procentDone = (100 / total) * count;
      }

      this.isLoading = false;
      this.procentDone = 0;
      return results;
    },
    async HandleChange(fileList) {
      try {
        this.isLoading = true;
        let count = 0;
        let total = fileList.length;

        for (let file of fileList) {
          count = count + 1;
          let url = await this.GetLocalImageUrl(file);
          let binary = await this.GetLocalImageBinaryString(file);
          this.images = [
            { url, binary, size: file.size, ext: file.name.split(".").pop() },
            ...this.images
          ];

          this.procentDone = (100 / total) * count;
        }

        this.isLoading = false;
        this.procentDone = 0;
      } catch (err) {
        console.log(err);
      }
    },
    HandleRemove(image) {
      this.images = this.images.filter(x => x !== image);
    },
    GetLocalImageUrl(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = function(progress) {
          resolve(progress.currentTarget.result);
        };

        reader.onerror = function(err) {
          reject(err);
        };

        reader.readAsDataURL(file);
      });
    },

    GetLocalImageBinaryString(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = function(progress) {
          resolve(progress.currentTarget.result);
        };

        reader.onerror = function(err) {
          reject(err);
        };

        reader.readAsBinaryString(file);
      });
    }
  }
};
</script>
